module.exports = __webpack_public_path__ + "img/FooterLogo.b3e43aab.svg";